import MaintenancePage from './MaintenancePage';
import { MaintenancePageProps, MaintenancePageValueProps } from './types';

export type { MaintenancePageProps, MaintenancePageValueProps };
export default MaintenancePage;